import { Link } from "react-router-dom";
import { Lock, ArrowRight, CandlestickChart, ScanEye, Trophy } from "lucide-react";
import { AppShell } from "./AppShell";

const FEATURES = {
  trading: {
    icon: CandlestickChart,
    title: "Trading avec Sara",
    desc: "Le desk institutionnel piloté 24/7 par Sara — signaux IA, gestion stricte du risque et comité d'investissement.",
  },
  vision: {
    icon: ScanEye,
    title: "Vision temps réel",
    desc: "Sara voit, diagnostique et vous guide à la voix, en direct.",
  },
  football: {
    icon: Trophy,
    title: "Football — Analyse & cotes",
    desc: "Probabilités estimées et comparaison avec les cotes réelles des bookmakers.",
  },
};

export function PremiumRequired({ feature = "trading" }) {
  const f = FEATURES[feature] || FEATURES.trading;
  const Icon = f.icon;
  return (
    <AppShell title={f.title} subtitle="Fonction réservée aux offres Pro & Entreprise">
      <div data-testid="premium-gate" className="mx-auto max-w-lg text-center py-16">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full border border-[var(--accent)] bg-[var(--accent-a10)]">
          <Icon className="h-7 w-7 accent-text" />
        </div>
        <div className="mb-3 inline-flex items-center gap-1.5 font-mono-hud text-[10px] uppercase tracking-[0.25em] text-[#8b949e]">
          <Lock className="h-3.5 w-3.5" /> Offre premium
        </div>
        <h2 className="font-display text-2xl font-black text-white">{f.title}</h2>
        <p className="mt-3 text-sm leading-relaxed text-[#9fb0c3]">{f.desc}</p>
        <p className="mt-2 text-sm text-[#9fb0c3]">
          Cette fonction est incluse dans les offres{" "}
          <span className="accent-text font-bold">Pro</span> et{" "}
          <span className="accent-text font-bold">Entreprise</span>.
        </p>
        <Link
          to="/compte"
          data-testid="premium-upgrade-button"
          className="hud-btn clip-corner mt-7 inline-flex items-center gap-2 px-6 py-3.5 text-sm font-bold"
        >
          Passer à Pro ou Entreprise <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </AppShell>
  );
}
